import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Debugging Applications</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Activities</AnchorLink>
    </AnchorLinks>
    <h1>{`Debugging Applications`}</h1>
    <p>{`Kubernetes provides tools to help troubleshoot and debug problems with applications.`}</p>
    <p>{`Usually is getting familiar with how primitives objects interact with each other, checking the status of objects, and finally checking logs for any last resource clues.`}</p>
    <h2>{`Resources`}</h2>
    <p><strong parentName="p">{`OpenShift`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/cli_reference/openshift_developer_cli/debugging-applications-in-odo.html"
        }}>{`Debugging Applications`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/metering/metering-troubleshooting-debugging.html"
        }}>{`Debugging Metrics`}</a></li>
    </ul>
    <p><strong parentName="p">{`IKS`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/tasks/debug-application-cluster/debug-application/"
        }}>{`Debugging Applications`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/tasks/debug-application-cluster/debug-service/"
        }}>{`Debugging Services`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/tasks/debug-application-cluster/debug-pod-replication-controller/"
        }}>{`Debugging Replication Controllers`}</a></li>
    </ul>
    <h2>{`References`}</h2>
    <Tabs mdxType="Tabs">
      <Tab label="OpenShift" mdxType="Tab">
        <p><strong parentName="p">{` Broken setup to debug`}</strong></p>
        <pre><code parentName="pre" {...{}}>{`curl -sL https://gist.githubusercontent.com/csantanapr/e823b1bfab24186a26ae4f9ec1ff6091/raw/1e2a0cca964c7b54ce3df2fc3fbf33a232511877/debugk8s.64 | base64 -d | oc apply -f -
`}</code></pre>
        <p><strong parentName="p">{` Expose the service using port-forward `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc port-forward service/my-service 8080:80 -n debug
`}</code></pre>
        <p><strong parentName="p">{` Try to access the service `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`curl http://localhost:8080
`}</code></pre>
        <p><strong parentName="p">{` Try Out these Commands to Debug `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc get pods --all-namespaces
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc get deployments
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc describe pod
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc explain Pod.spec.containers.resources.requests
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc explain Pod.spec.containers.livenessProbe
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc edit deployment
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc logs
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc get service
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc get ep
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc describe service
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc get pods --show-labels
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`oc get deployment --show-labels
`}</code></pre>
      </Tab>
      <Tab label="IKS" mdxType="Tab">
        <p><strong parentName="p">{` Broken setup to debug`}</strong></p>
        <pre><code parentName="pre" {...{}}>{`curl -s https://gist.githubusercontent.com/csantanapr/e823b1bfab24186a26ae4f9ec1ff6091/raw/a92550dd499ebefc205fa2cd5c18123409186712/debugk8s.64 | base64 -d | kubectl apply -f -
`}</code></pre>
        <p><strong parentName="p">{` Expose the service using port-forward `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl port-forward service/my-service 8080:80 -n debug
`}</code></pre>
        <p><strong parentName="p">{` Try to access the service `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`curl http://localhost:8080
`}</code></pre>
        <p><strong parentName="p">{` Try Out these Commands to Debug `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl get pods --all-namespaces
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl get deployments
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl describe pod
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl explain Pod.spec.containers.resources.requests
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl explain Pod.spec.containers.livenessProbe
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl edit deployment
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl logs
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl get service
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl get ep
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl describe service
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl get pods --show-labels
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl get deployment --show-labels
`}</code></pre>
      </Tab>
    </Tabs>
    <h3>{`Solution`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://gist.github.com/csantanapr/e823b1bfab24186a26ae4f9ec1ff6091#file-debugk8s-yaml"
        }}>{`https://gist.github.com/csantanapr/e823b1bfab24186a26ae4f9ec1ff6091#file-debugk8s-yaml`}</a></li>
    </ul>
    <h2>{`Activities`}</h2>
    <p>{`The continuous integration activities focus around Tekton the integration platform. These labs will show you how to build pipelines and test your code before deployment.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Task`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Link`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{` Try It Yourself `}</em></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Debugging`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Find which service is breaking in your cluster and find out why.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "../activities/labs/lab5"
            }}>{`Debugging`}</a></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      